import { render, staticRenderFns } from "./GenEdit.vue?vue&type=template&id=4c41562a&scoped=true"
import script from "./GenEdit.vue?vue&type=script&lang=js"
export * from "./GenEdit.vue?vue&type=script&lang=js"
import style0 from "./GenEdit.vue?vue&type=style&index=0&id=4c41562a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c41562a",
  null
  
)

export default component.exports